class ImageCache {
  constructor () {
    this.cache = new Map()

    const storedCache = localStorage.getItem('imageCache')
    if (storedCache) {
      this.cache = new Map(JSON.parse(storedCache))
    }
  }

  exists (key) {
    return this.cache.has(key)
  }

  set (key, value) {
    this.cache.set(key, value)
    this.persist()
  }

  get (key) {
    return this.cache.get(key)
  }

  delete (key) {
    this.cache.delete(key)
    this.persist()
  }

  persist () {
    localStorage.setItem(
      'imageCache',
      JSON.stringify(Array.from(this.cache.entries())),
    )
  }
}

class GridView extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.cache = new ImageCache()
  }

  connectedCallback () {
    super.connectedCallback()
    this.staggerImages()
  }

  staggerImages () {
    const images = Array.from(this.querySelectorAll('img'))
    const shuffledImages = this.shuffleArray(images)

    shuffledImages.forEach((img, index) => {
      if (this.cache.exists(img.src) && this.cache.get(img.src)) {
        this.log(`Image already cached: ${img.src}`)
        this.applyImmediateLoad(img)
      } else {
        this.log(`Preloading image: ${img.src}`)
        this.preloadImage(img, index)
      }
    })
  }

  preloadImage (img, index) {
    const tempImage = new Image()
    tempImage.onload = () => {
      this.cache.set(img.src, true)
      this.applyTransition(img, index)
    }
    tempImage.onerror = () => {
      console.error(`Failed to load image: ${img.src}`)
      this.cache.set(img.src, false)
    }
    tempImage.src = img.src
  }

  applyImmediateLoad (img) {
    img.classList.add('rsp-Image_Image-loaded', 'rsp-Image_Image-cached')
  }

  applyTransition (img, index) {
    setTimeout(() => {
      img.classList.add('rsp-Image_Image-loaded')
    }, index * 50)
  }

  shuffleArray (array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]]
    }
    return array
  }
}

if (!customElements.get('grid-view')) {
  customElements.define('grid-view', GridView)
}
